import React from 'react';
import { useTranslation } from 'react-i18next';

const TourPackages = () => {
    const { t } = useTranslation('tourPackages');

    const heroImage =
        'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=1800&q=80';

    const tokyoImage =
        'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?auto=format&fit=crop&w=1200&q=80';

    const fujiImage =
        'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?auto=format&fit=crop&w=1200&q=80';

    const kyotoImage =
        'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=1200&q=80';

    // Recommended Package Images
    const fiveDaysImage =
        'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?auto=format&fit=crop&w=1200&q=80'; // Tokyo + Fuji

    const sevenDaysImage =
        'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=1200&q=80'; // Kyoto / Cultural

    const tenDaysImage =
        'https://images.unsplash.com/photo-1528360983277-13d401cdc186?auto=format&fit=crop&w=1200&q=80'; // Hakone Scenic

    const twelveToFourteenDaysImage =
        'https://images.unsplash.com/photo-1623341214825-9f4f963727da?auto=format&fit=crop&w=1200&q=80'; // Miyajima Torii

    const familyImage =
        'https://images.unsplash.com/photo-1526481280693-3bfa7568e0f3?auto=format&fit=crop&w=1200&q=80';

    return (
        <div className="bg-[#07111f] text-white">
            {/* Hero Section */}
            <section className="relative overflow-hidden">
                <img
                    src={heroImage}
                    alt={t('hero.tagline2')}
                    className="absolute inset-0 h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-[#07111f]/90 via-[#07111f]/75 to-[#07111f]/40" />

                <div className="relative mx-auto flex min-h-[78vh] max-w-7xl items-center px-6 py-24 sm:px-10 lg:px-16">
                    <div className="max-w-3xl">
                        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.35em] text-[#f7d774]">
                            {t('hero.discover')}
                        </p>
                        <h1 className="font-serif text-4xl font-semibold leading-tight sm:text-5xl lg:text-6xl">
                            <span className="block text-[#7fd3ff]">{t('hero.starLankaTours')}</span>
                            <span className="mt-3 block text-white">{t('hero.highlight')}</span>
                        </h1>
                        <p className="mt-6 max-w-2xl text-lg leading-8 text-white/90 sm:text-xl">
                            {t('hero.tagline1')}
                        </p>
                        <p className="mt-4 max-w-2xl text-base leading-7 text-white/80 sm:text-lg">
                            {t('hero.tagline2')}
                        </p>
                    </div>
                </div>
            </section>

            {/* Overview Cards Section */}
            <section className="mx-auto max-w-7xl px-6 py-20 sm:px-10 lg:px-16">
                <div className="mb-10 max-w-3xl">
                    <p className="text-sm font-semibold uppercase tracking-[0.35em] text-[#7fd3ff]">
                        {t('overview.eyebrow')}
                    </p>
                    <h2 className="mt-4 font-serif text-3xl font-semibold text-white sm:text-4xl">
                        {t('overview.title')}
                    </h2>
                    <p className="mt-5 text-lg leading-8 text-white/80">
                        {t('overview.description')}
                    </p>
                </div>

                <div className="grid gap-6 lg:grid-cols-3">
                    {/* Existing 3 cards remain unchanged */}
                    <article className="overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)]">
                        <img src={tokyoImage} alt={t('cards.classicAlt')} className="h-56 w-full object-cover" />
                        <div className="p-7">
                            <h3 className="text-2xl font-semibold text-[#7fd3ff]">{t('cards.classicTitle')}</h3>
                            <p className="mt-3 text-sm font-semibold uppercase tracking-[0.25em] text-[#f7d774]">{t('cards.classicMeta')}</p>
                            <p className="mt-4 text-base leading-7 text-white/80">{t('cards.classicText')}</p>
                        </div>
                    </article>

                    <article className="overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)]">
                        <img src={fujiImage} alt={t('cards.culturalAlt')} className="h-56 w-full object-cover" />
                        <div className="p-7">
                            <h3 className="text-2xl font-semibold text-[#7fd3ff]">{t('cards.culturalTitle')}</h3>
                            <p className="mt-3 text-sm font-semibold uppercase tracking-[0.25em] text-[#f7d774]">{t('cards.culturalMeta')}</p>
                            <p className="mt-4 text-base leading-7 text-white/80">{t('cards.culturalText')}</p>
                        </div>
                    </article>

                    <article className="overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)]">
                        <img src={kyotoImage} alt={t('cards.natureAlt')} className="h-56 w-full object-cover" />
                        <div className="p-7">
                            <h3 className="text-2xl font-semibold text-[#7fd3ff]">{t('cards.natureTitle')}</h3>
                            <p className="mt-3 text-sm font-semibold uppercase tracking-[0.25em] text-[#f7d774]">{t('cards.natureMeta')}</p>
                            <p className="mt-4 text-base leading-7 text-white/80">{t('cards.natureText')}</p>
                        </div>
                    </article>
                </div>
            </section>

            {/* Highlights Section - unchanged */}
            <section className="border-y border-white/10 bg-[#0b1527]">
                <div className="mx-auto grid max-w-7xl gap-10 px-6 py-20 sm:px-10 lg:grid-cols-[1.15fr_0.85fr] lg:px-16">
                    <div>
                        <p className="text-sm font-semibold uppercase tracking-[0.35em] text-[#f7d774]">
                            {t('highlights.eyebrow')}
                        </p>
                        <h2 className="mt-4 font-serif text-3xl font-semibold text-white sm:text-4xl">
                            {t('highlights.title')}
                        </h2>
                        <p className="mt-5 text-lg leading-8 text-white/80">
                            {t('highlights.text')}
                        </p>
                    </div>

                    <div className="space-y-5">
                        <div className="rounded-[1.25rem] border border-[#7fd3ff]/20 bg-white/5 p-6">
                            <h3 className="text-xl font-semibold text-[#7fd3ff]">{t('highlights.seasonalTitle')}</h3>
                            <p className="mt-3 text-base leading-7 text-white/80">{t('highlights.seasonalText')}</p>
                        </div>
                        <div className="rounded-[1.25rem] border border-[#7fd3ff]/20 bg-white/5 p-6">
                            <h3 className="text-xl font-semibold text-[#7fd3ff]">{t('highlights.familyTitle')}</h3>
                            <p className="mt-3 text-base leading-7 text-white/80">{t('highlights.familyText')}</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Recommended Tour Packages */}
            <section className="mx-auto max-w-7xl px-6 py-20 sm:px-10 lg:px-16">
                <div className="mb-10 max-w-3xl">
                    <p className="text-sm font-semibold uppercase tracking-[0.35em] text-[#f7d774]">{t('recommended.eyebrow')}</p>
                    <h2 className="mt-4 font-serif text-3xl font-semibold text-white sm:text-4xl">{t('recommended.title')}</h2>
                    <p className="mt-5 text-lg leading-8 text-white/80">{t('recommended.subtitle')}</p>
                </div>

                <div className="grid gap-6 lg:grid-cols-2">
                    <article className="overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)]">
                        <img src={fiveDaysImage} alt={t('recommended.packages.fiveDays.alt')} className="h-56 w-full object-cover" />
                        <div className="p-7">
                            <h3 className="text-2xl font-semibold text-[#7fd3ff]">{t('recommended.packages.fiveDays.title')}</h3>
                            <p className="mt-4 text-base leading-7 text-white/80">{t('recommended.packages.fiveDays.description')}</p>
                        </div>
                    </article>

                    <article className="overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)]">
                        <img src={sevenDaysImage} alt={t('recommended.packages.sevenDays.alt')} className="h-56 w-full object-cover" />
                        <div className="p-7">
                            <h3 className="text-2xl font-semibold text-[#7fd3ff]">{t('recommended.packages.sevenDays.title')}</h3>
                            <p className="mt-4 text-base leading-7 text-white/80">{t('recommended.packages.sevenDays.description')}</p>
                        </div>
                    </article>

                    <article className="overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)]">
                        <img src={tenDaysImage} alt={t('recommended.packages.tenDays.alt')} className="h-56 w-full object-cover" />
                        <div className="p-7">
                            <h3 className="text-2xl font-semibold text-[#7fd3ff]">{t('recommended.packages.tenDays.title')}</h3>
                            <p className="mt-4 text-base leading-7 text-white/80">{t('recommended.packages.tenDays.description')}</p>
                        </div>
                    </article>

                    <article className="overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)]">
                        <img src={twelveToFourteenDaysImage} alt={t('recommended.packages.twelveToFourteenDays.alt')} className="h-56 w-full object-cover" />
                        <div className="p-7">
                            <h3 className="text-2xl font-semibold text-[#7fd3ff]">{t('recommended.packages.twelveToFourteenDays.title')}</h3>
                            <p className="mt-4 text-base leading-7 text-white/80">{t('recommended.packages.twelveToFourteenDays.description')}</p>
                        </div>
                    </article>
                </div>
            </section>

            {/* CTA Section */}
            <section className="mx-auto max-w-7xl px-6 py-20 sm:px-10 lg:px-16">
                <div className="overflow-hidden rounded-[2rem] bg-white text-[#07111f] shadow-[0_25px_80px_rgba(0,0,0,0.18)]">
                    {/* Mobile layout - visible only on small screens */}
                    <div className="block sm:hidden">
                        <div className="p-8 text-center">
                            <p className="text-sm font-semibold uppercase tracking-[0.35em] text-[#1d4ed8]">
                                {t('cta.eyebrow')}
                            </p>
                            <h2 className="mt-4 font-serif text-3xl font-semibold">
                                {t('cta.title')}
                            </h2>
                            <img src={familyImage} alt={t('cta.imageAlt')} className="mt-6 h-[280px] w-full rounded-[1.25rem] object-cover" />
                            <p className="mt-6 text-base leading-7 text-gray-700">
                                {t('cta.text')}
                            </p>
                            <div className="mt-8 flex justify-center">
                                <a
                                    href="https://wa.me/819082514053?text=Hello%20Sonic%20Tours!%20I%20would%20like%20to%20plan%20a%20Japan%20tour."
                                    target="_blank"
                                    rel="noreferrer"
                                    className="rounded-full bg-[#1d4ed8] px-6 py-3 font-semibold text-white transition hover:bg-[#153e75]"
                                >
                                    {t('cta.button')}
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Desktop layout - hidden on small screens */}
                    <div className="hidden sm:flex lg:flex-row">
                        <div className="flex-1 p-8 sm:p-10 lg:p-12">
                            <p className="text-sm font-semibold uppercase tracking-[0.35em] text-[#1d4ed8]">
                                {t('cta.eyebrow')}
                            </p>
                            <h2 className="mt-4 font-serif text-3xl font-semibold sm:text-4xl">
                                {t('cta.title')}
                            </h2>
                            <p className="mt-5 text-lg leading-8 text-gray-700">
                                {t('cta.text')}
                            </p>
                            <div className="mt-8 flex flex-wrap gap-4">
                                <a
                                    href="https://wa.me/819082514053?text=Hello%20Sonic%20Tours!%20I%20would%20like%20to%20plan%20a%20Japan%20tour."
                                    target="_blank"
                                    rel="noreferrer"
                                    className="rounded-full bg-[#1d4ed8] px-6 py-3 font-semibold text-white transition hover:bg-[#153e75]"
                                >
                                    {t('cta.button')}
                                </a>
                            </div>
                        </div>
                        <div className="flex-1">
                            <img src={familyImage} alt={t('cta.imageAlt')} className="h-full min-h-[280px] w-full object-cover" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TourPackages;